import $ from 'jquery';

export const init = () => {
	$(document).on('click', '.js-tabs-link', function (e) {
		e.preventDefault();

		const $this = $(this);
		const $closest = $this.closest('.js-tabs');
		const $items = $closest.find('.js-tabs-item');
		const $tabs = $closest.find('.js-tabs-content');

		$items.removeClass('is-active');
		$tabs.removeClass('is-active');

		$this.parent().addClass('is-active');
		$tabs.filter($this.attr('href')).addClass('is-active');
	});
};
